import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetAssessmentModelList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/assessments/${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetAssessmentModel = async function(assessmentModelPublicId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/assessment/${assessmentModelPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const UpdateAssessmentModel = async function(assessmentModel) {
    try {
        const { publicId } = assessmentModel
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment/${publicId}`,
            data: assessmentModel,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const PostAssessmentModel = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/assessment`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const PostAssessmentQuestion = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/assessment-question`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeleteAssessmentModel = async function(parameters) {
    try {
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: parameters')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/assessment/`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeAssessmentModelStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment/${publicId}/change-current`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetAssessmentQuestion = async function(
    assessmentQuestionPublicId
) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/assessment-question/${assessmentQuestionPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const UpdateAssessmentQuestion = async function(assessmentQuestion) {
    try {
        const { publicId } = assessmentQuestion
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}assessment-question/${publicId}`,
            data: assessmentQuestion,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeleteAssessmentQuestion = async function(publicIds) {
    try {
        if (publicIds === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicIds')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/assessment-question/`,
            data: publicIds,
        })
    } catch (e) {
        console.error(e)
    }
}
